var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDensity),expression:"showDensity"}],staticClass:"density-bar",class:{'density-bar-invis': !_vm.hasAnchor},style:(_vm.barStyle)},[_c('canvas',{ref:"canvas",staticClass:"density-content",attrs:{"width":"15"},on:{"click":function($event){return _vm.clickDensityBar($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }